export default __webpack_public_path__ + "static/media/motl.513d33ee.png";